<template>
  <li class="calendar__event-item section__item page-card-block page-card-block--has-date-field"
       :class="calendarEventItem.IsRecurring ? 'calendar__event-item--recurring' : ''"
       @click="goToPage(calendarEventItem.EventUrl)">
    <article class="page-card-block__content">
      <figure v-if="calendarEventItem.ImageHtmlTag" class="page-card-block__image-container" v-html="calendarEventItem.ImageHtmlTag"></figure>
      <div v-if="!calendarEventItem.ImageHtmlTag" class="page-card-block__no-image-container">
        <span class="page-card-block__no-image-container-graphic"></span>
      </div>
      <div class="page-card-block__text-container">
        <div class="page-card-block__date-field">
          <span class="calendar__event-item--date-field-text" v-html="calendarDate"></span>
        </div>
        <ul v-if="!!calendarEventItem.CompleteTags?.length" class="page-card-block__category-list tag-container">
          <li class="page-card-block__category-item tag tag--small" v-for="(tag) in calendarEventItem.CompleteTags">
            {{ tag.TagName }}
          </li>
        </ul>
        <h3 class="page-card-block__heading heading heading--small">
          <a v-bind:href="calendarEventItem.EventUrl" class="page-card-block__link">
            {{ calendarEventItem.Heading }}
          </a>
        </h3>
        <p class="page-card-block__excerpt" v-html="calendarEventItem.MainIntro"></p>
        <div class="page-card-block__arrow-icon-container">
          <span class="page-card-block__arrow-icon icon icon--arrow-right"></span>
        </div>
      </div>
    </article>
  </li>
</template>

<script>
export default {
  name: "CalendarEventItem",
  props: {
    calendarEventItem: {},
    translations: {},
    culture: "",
  },
  methods: {
    goToPage(link) {
      window.location.href = link;
    },

    // For single: Trim ONLY the second line (after <br/>) to N characters + "..."
    truncateSecondLine(html, maxLen = 4) {
      if (!html) return "";
      const parts = html.split(/<br\s*\/?>/i);
      if (parts.length === 1) return html; // no second line

      const line1 = parts[0];
      let line2 = parts.slice(1).join(" ").replace(/&nbsp;/gi, " ").trim();

      // Capitalize the month initial if pattern is "dd m"
      line2 = line2.replace(
          /^(\d{1,2}\s*)([A-Za-zÅÄÖåäöÀ-ÖØ-öø-ÿ])/u,
          (_, d, ch) => d + ch.toUpperCase()
      );

      const short = line2.slice(0, maxLen);
      // basic escaping for < and >
      const esc = short.replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return `${line1}<br/>${esc}...`;
    },

    // For recurring: keep line 1, make line 2 = FIRST WORD + "..."
    firstWordSecondLine(html, forceUpper = true, ellipsis = "...") {
      if (!html) return "";
      const parts = html.split(/<br\s*\/?>/i);
      if (parts.length === 1) return html; // no second line

      const line1 = parts[0];
      let line2 = parts.slice(1).join(" ").replace(/&nbsp;/gi, " ").trim();

      // Grab the first word (allowing nordic letters)
      const m = line2.match(/^([A-Za-zÅÄÖåäöÀ-ÖØ-öø-ÿ]+)/u);
      const first = m ? m[1] : (line2.split(/\s+/)[0] || "");
      const out = forceUpper ? first.toUpperCase() : first;

      return `${line1}<br/>${out}${ellipsis}`;
    }
  },

  computed: {
    calendarDate() {
      const startDate = new Date(this.calendarEventItem.Start);

      if (this.calendarEventItem.DisplayString) {
        if (this.calendarEventItem.IsRecurring) {
          return this.firstWordSecondLine(this.calendarEventItem.DisplayString, true, "...");
        }
        return this.truncateSecondLine(this.calendarEventItem.DisplayString, 4);
      }

      if (this.calendarEventItem.IsRecurring) {
        const endDate = new Date(this.calendarEventItem.PeriodEndDate);
        const startDayAndMonth = startDate
            .toLocaleDateString(this.culture, { day: "numeric", month: "short" })
            .replaceAll(".", "");
        const startTime = startDate.toLocaleTimeString(this.culture, { hour: "2-digit", minute: "2-digit" });
        const endDayAndMonth = endDate
            .toLocaleDateString(this.culture, { day: "numeric", month: "short" })
            .replaceAll(".", "");
        const timeString = this.translations.SeveralTimes;

        let line1;
        if (startDate.getMonth() === endDate.getMonth()) {
          line1 = `${startDate.getDate()} - ${endDayAndMonth}, ${this.calendarEventItem.NumberOfSchedulings > 1 ? timeString : startTime}`;
        } else {
          line1 = `${startDayAndMonth} - ${endDayAndMonth}, ${this.calendarEventItem.NumberOfSchedulings > 1 ? timeString : startTime}`;
        }

        return line1;
      }

      const single = startDate.toLocaleDateString(this.culture, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      });
      return single;
    },
  },
};
</script>


